import clientSubscription from '@/utils/client.subscription'

const MUTATION_TYPES = {
  UPDATE_QUIZ_RESPONSE: 'UPDATE_QUIZ_RESPONSE',
}

const _state = {
  quizResult: null,
}

const _getters = {
  quizResult: (state) => {
    return state.quizResult
  },
}

const actions = {
  subscribeQuizResponseAction: async ({ dispatch }, payload) => {
    const { audienceId } = payload
    await dispatch('kvSync/subscribeKeyAction', {
      key: `QUIZ_RESULTS/${audienceId}`,
    }, {
      root: true,
    })
  },
}

const mutations = {
  [MUTATION_TYPES.UPDATE_QUIZ_RESPONSE](state, quizResult) {
    state.quizResult = quizResult
  },
}

const plugins = {
  updateQuizResponse: (store) => {
    store.subscribeAction((action) => {
      if (action.type === 'kvSync/updateKeyValueAction') {
        const { key, value } = action.payload
        if (key.includes('QUIZ_RESULTS/') && value) {
          const quizResult = JSON.parse(value)
          const keySubscrible = `${clientSubscription.constantObjectSubcriptionType.submitQuizAnswerType}-${quizResult.slide}`
          if (clientSubscription.objectSubcription[keySubscrible]) {
            if (!quizResult.id) quizResult.id = 1
            clientSubscription.objectSubcription[keySubscrible].resolve(quizResult)
            delete clientSubscription.objectSubcription[keySubscrible] // Sau khi resolve, xóa đi khỏi objectSub (hoặc giữ lại nếu cần)
          }
          // store.commit(MUTATION_TYPES.UPDATE_QUIZ_RESPONSE, quizResult)
        }
      }
    })
  },
}

const quizModule = {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
  plugins,
}

export default quizModule
